<template>
  <div>
    <div class="card">
      <div class="card-header">
        <div class="card-title">Serviços Adicionais Solicitados</div>
      </div>
      <div class="card-body mt-4">
        <div class="row mb-4">
          <div class="col-md-2" align="left">
            <button class="btn btn-add" type="button" @click="collapseToggle">
              <i class="fas fa-filter"></i> Filtros
            </button>
          </div>
          <div class="col-md-2">
            <button class="btn btn-add" type="button" @click="getEntity">
              <i class="fas fa-sync-alt"></i> Atualizar
            </button>
          </div>
        </div>

        <div class="row mb-3" v-if="collapse == 1">
          <div class="col-md-6">
            <label>Filtrar Sala</label>
            <v-select
              :options="rooms"
              label="title"
              :reduce="(rooms) => rooms.id"
              multiple
              class="style-chooser"
              v-model="filters.room_id"
            >
              <div slot="no-options">Nenhum registro encontrado.</div>
            </v-select>
          </div>
          <div class="col-md-6">
            <label>Filtrar Serviço</label>
            <v-select
              :options="additionals"
              label="title"
              :reduce="(additionals) => additionals.id"
              multiple
              class="style-chooser"
              v-model="filters.additional_id"
            >
              <div slot="no-options">Nenhum registro encontrado.</div>
            </v-select>
          </div>
          <div class="col-md-4 mt-2">
            <label>Status</label>
            <v-select
              :options="status"
              label="text"
              :reduce="(status) => status.id"
              multiple
              class="style-chooser"
              v-model="filters.status"
            >
              <div slot="no-options">Nenhum registro encontrado.</div>
            </v-select>
          </div>
          <div class="col-md-4 mt-2">
            <label>Data de Início</label>
            <input
              type="date"
              class="form-control"
              v-model="filters.date_start"
            />
          </div>
          <div class="col-md-4 mt-2">
            <label>Data Final</label>
            <input
              type="date"
              class="form-control"
              v-model="filters.date_end"
            />
          </div>
          <div class="col-md-12 mt-4 mb-3" align="center">
            <button class="btn btn-add" @click="getEntity()">Pesquisar</button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <table class="table" style="font-size: 14px">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Serviço</th>
                  <th scope="col">Solicitante</th>
                  <th scope="col">Data</th>
                  <th scope="col">Sala</th>
                  <th scope="col">E-mail Responsável</th>
                  <th scope="col">Status</th>
                  <th scope="col">Ação</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="service in services" :key="service.id">
                  <td>{{ service.id }}</td>
                  <td>{{ service.additional.title }}</td>
                  <td>{{ service.reserve.user.name }}</td>
                  <td>{{ service.reserve.date_start }}</td>
                  <td>{{ service.reserve.room.title }}</td>
                  <td>
                    {{
                      service.additional.email
                        ? service.additional.email
                        : "Não enviado"
                    }}
                  </td>
                  <td>
                    <h6>
                      <span
                        v-if="service.status == 0"
                        class="badge badge-warning"
                        >Aguardando</span
                      >
                      <span
                        v-if="service.status == 1"
                        class="badge badge-primary"
                        >Em andamento</span
                      >
                      <span
                        v-if="service.status == 2"
                        class="badge badge-success"
                        >Finalizado</span
                      >
                    </h6>
                  </td>
                  <td>
                    <button
                      class="btn btn-add"
                      @click="dataModal = service"
                      data-toggle="modal"
                      data-target="#modalManage"
                    >
                      <i class="fas fa-eye"></i>
                    </button>
                  </td>
                </tr>
                <tr v-if="services.length == 0">
                  <td colspan="8" align="center">
                    Nenhum registro encontrado.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-md-12">
            <pagination
              :records="total"
              :options="options"
              :per-page="10"
              @paginate="getEntity"
            ></pagination>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div
      class="modal fade"
      id="modalManage"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalManageLabel"
      aria-hidden="true"
      v-if="dataModal != null"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div class="row justify-content-center mt-3">
              <div class="col-md-12 centered bold" style="font-size: 16px">
                Serviço Solicitado
              </div>
              <div class="col-md-12 centered mt-1" style="font-size: 20px">
                {{ dataModal.additional.title }}
              </div>
              <div class="col-md-12 centered mt-1" style="font-size: 16px">
                Descrição: {{ dataModal.additional.description }}
              </div>
              <div class="col-md-11 mt-4 bold">
                <label for="title">Título da Reunião</label>
                <input
                  type="text"
                  disabled
                  v-model="dataModal.reserve.title"
                  name="title"
                  class="form-control"
                  id
                />
              </div>
              <div class="col-md-4 mt-3">
                <div class="form-group bold">
                  <label for="inputPlace">Data Início</label>
                  <input
                    type="text"
                    disabled
                    class="form-control"
                    v-model="dataModal.reserve.date_start"
                  />
                </div>
              </div>
              <div class="col-md-4 mt-3">
                <div class="form-group bold">
                  <label for="inputPlace">Data Final</label>
                  <input
                    type="text"
                    disabled
                    class="form-control"
                    v-model="dataModal.reserve.date_end"
                  />
                </div>
              </div>
              <div class="col-md-12 mt-3">
                <div class="container-fluid">
                  <div class="row justify-content-center">
                    <!-- Room Card -->
                    <div class="col-md-6">
                      <div class="card">
                        <img
                          class="card-img-top"
                          :src="dataModal.reserve.room.photo"
                          alt
                        />

                        <div class="card-body">
                          <div class="room-name">
                            {{ dataModal.reserve.room.title }}
                            <span class="room-distance">{{
                              dataModal.reserve.room.tag
                            }}</span>
                          </div>
                          <div class="room-info">
                            <label>Adicionais da Sala</label>
                            <div class="room-place">
                              <span
                                class="badge badge-secondary lg-badge"
                                v-for="detail in dataModal.reserve.room.details"
                                :key="detail.id"
                                style="padding 3px"
                                >{{ detail.detail.title }}</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row text-center mb-3 mt-3">
              <div class="col">
                <button
                  class="btn btn-warning bold"
                  data-toggle="modal"
                  data-target="#modalManage"
                  @click="changeStatus(0)"
                >
                  Aguardando
                </button>
              </div>
              <div class="col">
                <button
                  class="btn btn-primary bold"
                  data-toggle="modal"
                  data-target="#modalManage"
                  @click="changeStatus(1)"
                >
                  Em andamento
                </button>
              </div>
              <div class="col">
                <button
                  class="btn btn-success bold"
                  data-toggle="modal"
                  data-target="#modalManage"
                  @click="changeStatus(2)"
                >
                  Finalizar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { Pagination } from "vue-pagination-2";
export default {
  data: function () {
    return {
      options: {
        texts: {
          count: "Mostrando {from} de {to} até {count} de registros",
        },
        chunk: 4,
        chunksNavigation: "fixed",
      },
      total: 0,
      page: 1,
      collapse: 0,
      services: [],
      additionals: [],
      rooms: [],
      filters: {
        status: [0, 1],
      },
      dataModal: null,
      status: [
        {
          id: 0,
          text: "Aguardando",
        },
        {
          id: 1,
          text: "Em andamento",
        },
        {
          id: 2,
          text: "Finalizado",
        },
      ],
    };
  },
  components: { vSelect, Pagination },
  methods: {
    getEntity(page) {
      const self = this;
      self.page = page;
      const api =
        self.$store.state.api + "services_additionals/manage?page=" + self.page;

      self.$http
        .post(api, self.filters)
        .then((response) => {
          self.services = response.data.data;
          self.total = response.data.total;
          self.$store.commit("updateNotifications");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    collapseToggle() {
      if (this.collapse == 1) {
        this.collapse = 0;
      } else {
        this.collapse = 1;
      }
    },
    changeStatus(status) {
      const self = this;
      const api = self.$store.state.api + "services_additionals/change-status";

      self.$http
        .post(api, { additional_id: self.dataModal.id, status: status })
        .then(() => {
          self.getEntity();
          self.$message(
            "Sucesso",
            "Adicional atualizado com sucesso",
            "success"
          );
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getRooms: function () {
      const self = this;
      const api = self.$store.state.api + "rooms?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.rooms = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getAdditionals: function () {
      const self = this;
      const api =
        self.$store.state.api + "services_additionals?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.additionals = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted() {
    this.getEntity();
    this.getRooms();
    this.getAdditionals();
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/ServicesAdditional/Manage.vue